(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dx-campaign-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const slides = Array.from(root.querySelectorAll('[data-dx-campaign-slide]'));
      if (slides.length < 2) return;
      const dots = Array.from(root.querySelectorAll('[data-dx-campaign-dot]'));
      const previous = root.querySelector('[data-dx-campaign-previous]');
      const next = root.querySelector('[data-dx-campaign-next]');
      const pause = root.querySelector('[data-dx-campaign-pause]');
      const pauseText = root.querySelector('[data-dx-campaign-pause-text]');
      const status = root.querySelector('[data-dx-campaign-status]');
      const interval = Math.max(Number(root.dataset.interval) || 5000, 3000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let timer;
      let userPaused = false;
      let interactionPaused = false;
      let inView = true;

      const announce = () => {
        if (!status) return;
        status.textContent = root.dataset.statusTemplate.replace('__CURRENT__', String(current + 1));
      };

      const schedule = () => {
        window.clearTimeout(timer);
        if (root.dataset.autoplay !== 'true' || userPaused || interactionPaused || !inView || document.hidden || reducedMotion.matches) return;
        timer = window.setTimeout(() => {
          show(current + 1, false);
        }, interval);
      };

      const show = (index, shouldAnnounce = true) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (shouldAnnounce) announce();
        schedule();
      };

      const updatePause = () => {
        if (!pause) return;
        const label = userPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
        pause.setAttribute('aria-pressed', String(userPaused));
        if (pauseText) pauseText.textContent = label;
        schedule();
      };

      previous?.addEventListener('click', () => show(current - 1));
      next?.addEventListener('click', () => show(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slideIndex))));
      pause?.addEventListener('click', () => {
        userPaused = !userPaused;
        updatePause();
      });
      root.addEventListener('pointerenter', () => {
        interactionPaused = true;
        schedule();
      });
      root.addEventListener('pointerleave', () => {
        interactionPaused = false;
        schedule();
      });
      root.addEventListener('focusin', () => {
        interactionPaused = true;
        schedule();
      });
      root.addEventListener('focusout', (event) => {
        if (root.contains(event.relatedTarget)) return;
        interactionPaused = false;
        schedule();
      });
      document.addEventListener('visibilitychange', schedule);
      reducedMotion.addEventListener?.('change', schedule);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries[0]?.isIntersecting ?? true;
          schedule();
        }, { threshold: 0.2 });
        observer.observe(root);
      }

      root.dxCampaignShow = show;
      root.dxCampaignPause = () => {
        userPaused = true;
        updatePause();
      };
      show(0, false);
    };

    document.querySelectorAll('[data-dx-campaign]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches?.('[data-dx-campaign]')) initialize(event.target);
      event.target.querySelectorAll?.('[data-dx-campaign]').forEach(initialize);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-dx-campaign-slide]');
      const root = slide?.closest('[data-dx-campaign]');
      if (!slide || !root?.dxCampaignShow) return;
      root.dxCampaignShow(Number(slide.dataset.slideIndex));
      root.dxCampaignPause?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
